import { bindable, resolve, IEventAggregator } from "aurelia";

export class PriceDisplay {

    @bindable hotel;
    @bindable uniqueId;

    aurelia_options = aurelia_options;
    eventAggregator = resolve(IEventAggregator);
    
    showHighlightClass = false;

    attached() {
        this.updateFilterSubscription = this.eventAggregator.subscribe('update-filter-' + this.uniqueId, params => this.updateFilterEvent(params));
        this.price = this.getSelectedOfferPrice(this.hotel);
    }

    detached() {
        this.updateFilterSubscription.dispose();
    }


    updateFilterEvent(params) {
        // data was updated either from roomtype selection or from mealplan selection
        // react only for mealplan update - roomtype update will trigger mealplan update
        this.price = params.mealplan.price;
        
        this.showHighlightClass = true;
        setTimeout(() => {
            this.showHighlightClass = false;
        }, 1500);
    }

    getSelectedOfferPrice(hotel) {
        return hotel.rooms.find(room => room.id === hotel.selected_room_id).mealplans.find(mealplan => mealplan.id === hotel.selected_mealplan_id).price;
    }
}